import { Session } from '@benzinga/session';
import { ListenableSubscribable } from '@benzinga/subscribable';
import { SafeError, SafePromise, SafeType } from '@benzinga/safe-await';
import { OptionChainRestful } from './restful';
import { OptionChainResponse } from './entities';

interface OptionChainEvent {
  error: SafeError;
  type: 'optionChain_event';
}

export class OptionChainRequest extends ListenableSubscribable<OptionChainEvent> {
  private restful: OptionChainRestful;
  constructor(session: Session) {
    super();
    this.restful = new OptionChainRestful(session);
  }

  // Add any type for temporary use
  public getOptionChain = async (symbols: string | string[]): SafePromise<OptionChainResponse> => {
    try {
      const res = (await this.restful.getOptionChain(symbols)) as SafeType<OptionChainResponse>;
      if (res.err) {
        return { err: res.err };
      } else {
        return res;
      }
    } catch (err: any) {
      return { err };
    }
  };
}
